module.exports = __webpack_public_path__ + "img/ENTP.50c56431.png";